var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, ChangeDetectorRef, ElementRef, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { CommunicationService } from '../../../services/communication.service';
import { TranslateService } from '@ngx-translate/core';
import { PreferencesService } from '../../../services/preferences.service';
import { Router } from '@angular/router';
import { Helper } from '../../../classes/helper';
import { Filters } from '../../../classes/user-preferences';
import { ListingsService } from '../../../services/listings.service';
import { FiltersCommercialComponent } from './filters-commercial.component';
import { SelectOption } from '../../forms/select/select.component';
import { UpdatedSince } from "../../../classes/enums";
var FiltersCommercialDesktopComponent = /** @class */ (function (_super) {
    __extends(FiltersCommercialDesktopComponent, _super);
    function FiltersCommercialDesktopComponent(preferencesService, communicationService, translateService, router, listingsService, fb, cd) {
        var _this = _super.call(this, preferencesService, communicationService, translateService, router, listingsService, fb, cd) || this;
        _this.preferencesService = preferencesService;
        _this.communicationService = communicationService;
        _this.translateService = translateService;
        _this.router = router;
        _this.listingsService = listingsService;
        _this.fb = fb;
        _this.cd = cd;
        _this.minSqftPriceOptions = [];
        _this.maxSqftPriceOptions = [];
        var listingTypesControls = _this.filtersForm.controls['listingTypes'];
        _this.listingType.forEach(function (it) {
            listingTypesControls.addControl(it, _this.fb.control(false));
        });
        return _this;
    }
    FiltersCommercialDesktopComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.minSqftPriceOptions = this.pricePerSqftValues.map(function (value) { return new SelectOption('$' + Helper.formatPrice(value), value); });
        this.maxSqftPriceOptions = this.pricePerSqftValues.map(function (value) { return new SelectOption('$' + Helper.formatPrice(value), value); });
        this.minSqftPriceOptions[0].key = 'filters.no-min';
        this.maxSqftPriceOptions[0].key = 'filters.no-max';
    };
    FiltersCommercialDesktopComponent.prototype.onPageClick = function ($event) {
        // TODO: this is triggering when you switch between luxury and residential and the form is reset, which causes the dropdowns to close when toggling a property type
        // Hide all the dropdowns if the dropdowns are open and they click something not a dropdown
        if ((this.showAllListingTypes || this.showAllBusinessTypes || this.showMore) && !this.formElementRef.nativeElement.contains($event.target)) {
            this.closeDropdowns();
        }
    };
    FiltersCommercialDesktopComponent.prototype._resetForm = function () {
        this.clearListingTypes();
        this.clearBusinessTypes();
        this.filtersForm.get('minPrice').patchValue(0);
        this.filtersForm.get('maxPrice').patchValue(0);
    };
    FiltersCommercialDesktopComponent.prototype.broadcastChangedFilters = function () {
        var value = Object.assign(new Filters(), this.filtersForm.value);
        if (this.isPricePerSqft) {
            value.pricePerSqFt.min = this.filtersForm.get('minPrice').value;
            value.pricePerSqFt.max = this.filtersForm.get('maxPrice').value;
            value.price = {};
        }
        else {
            value.price.min = this.filtersForm.get('minPrice').value;
            value.price.max = this.filtersForm.get('maxPrice').value;
            value.pricePerSqFt = {};
        }
        this._preferencesService.updateFilters(value);
        this.communicationService.searchParametersChanged.next();
    };
    FiltersCommercialDesktopComponent.prototype.updateMaxPriceOptions = function () {
        var minValue = this.filtersForm.controls['minPrice'].value;
        var maxValue = this.filtersForm.controls['maxPrice'].value;
        // Reset the max value in case the min value is greater
        if (minValue > maxValue) {
            this.filtersForm.controls['maxPrice'].setValue(0);
        }
        // Disable the max options if the min value is greater than the option
        if (this.isPricePerSqft) {
            this.maxSqftPriceOptions.forEach(function (option) {
                option.disabled = minValue > option.value && option.value !== 0;
                return option;
            });
        }
        else {
            this.maxPriceOptions = this.maxPriceOptions.map(function (option) {
                option.disabled = minValue > option.value && option.value !== 0;
                return option;
            });
        }
        this.cd.detectChanges();
    };
    /**
     * Close all dropdowns, and set the status of one dropdown to the desired status
     * @param dropdownName dropdownName we want to specifically toggle
     * @param newStatus the new status
     */
    FiltersCommercialDesktopComponent.prototype.closeDropdowns = function (dropdownName, newStatus) {
        this.showListingTypes = false;
        this.showBusinessTypes = false;
        this.showPrice = false;
        this.showMore = false;
        // this.showSize = false;
        if (dropdownName)
            this[dropdownName] = newStatus;
    };
    FiltersCommercialDesktopComponent.prototype.onSubmit = function () {
        this.closeDropdowns();
    };
    Object.defineProperty(FiltersCommercialDesktopComponent.prototype, "propertyText", {
        get: function () {
            var _this = this;
            var totalPropsEnabled = Object.keys(this.listingTypesFg.value).filter(function (key) { return _this.listingTypesFg.value[key]; }).length;
            return totalPropsEnabled > 0 ? "Property Types (" + totalPropsEnabled + ")" : 'All Property Types';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FiltersCommercialDesktopComponent.prototype, "businessText", {
        get: function () {
            var _this = this;
            if (!this.businessType.length)
                return '';
            var totalPropsEnabled = Object.keys(this.businessTypesFg.value).filter(function (key) { return _this.businessTypesFg.value[key]; }).length;
            return totalPropsEnabled > 0 ? "Business Types (" + totalPropsEnabled + ")" : 'All Business Types';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FiltersCommercialDesktopComponent.prototype, "priceText", {
        get: function () {
            var minPrice = this.filtersForm.controls['minPrice'].value;
            var maxPrice = this.filtersForm.controls['maxPrice'].value;
            // TODO: Translations
            if (minPrice === 0 && maxPrice === 0)
                return 'Any Price';
            else if (minPrice > 0 && maxPrice === 0)
                return Helper.toDollarMagnitudes(minPrice) + '+';
            else if (minPrice === 0 && maxPrice > 0)
                return Helper.toDollarMagnitudes(0) + ' - ' + Helper.toDollarMagnitudes(maxPrice);
            else
                return Helper.toDollarMagnitudes(minPrice) + ' - ' + Helper.toDollarMagnitudes(maxPrice);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FiltersCommercialDesktopComponent.prototype, "moreText", {
        get: function () {
            var totalExtraValuesEnabled = 0;
            if (this.filtersForm.get('stories').value.min || this.filtersForm.get('stories').value.max)
                totalExtraValuesEnabled++;
            if (this.filtersForm.get('size').value.min || this.filtersForm.get('size').value.max)
                totalExtraValuesEnabled++;
            if (this.filtersForm.get('units').value.min || this.filtersForm.get('units').value.max)
                totalExtraValuesEnabled++;
            if (this.filtersForm.get('totalAcres').value.min || this.filtersForm.get('totalAcres').value.max)
                totalExtraValuesEnabled++;
            if (this.filtersForm.get('parking').value.min || this.filtersForm.get('parking').value.max)
                totalExtraValuesEnabled++;
            if (this.filtersForm.get('updatedSince').value && this.filtersForm.get('updatedSince').value != UpdatedSince.ANY)
                totalExtraValuesEnabled++;
            // TODO: translation
            return 'More' + (totalExtraValuesEnabled > 0 ? " (" + totalExtraValuesEnabled + ")" : '');
        },
        enumerable: true,
        configurable: true
    });
    return FiltersCommercialDesktopComponent;
}(FiltersCommercialComponent));
export { FiltersCommercialDesktopComponent };
